import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../../../services/general.service';
import { DataService } from '../../../../utils/data.service';
import { DataSourceGrid } from '../../../../utils/data-source-grid.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
    selector: 'my-cuenta-generarXML',
    templateUrl: 'cuenta-generarXML.componen.html',
    providers: [generalService]
})
export class CuentaGenerarXMLComponent implements OnInit{
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    anioActual: number = new Date().getFullYear();
    mesActual: number = new Date().getMonth() + 1;
    aniosRestantes: number = 30; // Puedes ajustar este valor según lo necesites
    // Generar un rango de años desde el año actual hacia aniosRestantes años atrás
    anos: number[] = Array.from({ length: this.aniosRestantes + 1 }, (_, index) => this.anioActual - index);
    meses: { nombre: string, valor: number }[] = [
        { nombre: 'Enero', valor: 1 },
        { nombre: 'Febrero', valor: 2 },
        { nombre: 'Marzo', valor: 3 },
        { nombre: 'Abril', valor: 4 },
        { nombre: 'Mayo', valor: 5 },
        { nombre: 'Junio', valor: 6 },
        { nombre: 'Julio', valor: 7 },
        { nombre: 'Agosto', valor: 8 },
        { nombre: 'Septiembre', valor: 9 },
        { nombre: 'Octubre', valor: 10 },
        { nombre: 'Noviembre', valor: 11 },
        { nombre: 'Diciembre', valor: 12 }
    ];
    public rfcCompany = '';
    public list_XML: any[] = [];
    public anioXML = 0;
    public mesXML = "";
  
    constructor(private formBuilder: FormBuilder,
                private _generalService: generalService,
                public dataService: DataService,
                public dialog: MatDialog) {
                    this.myForm = new FormGroup({});
    }
   
  
    ngOnInit() {
       this.buildForm();
    }
   
    cerrarModal(){
        this.dataService.dialogRef.close();
    }
    buildForm() {
        this.myForm = this.formBuilder.group({
            anioForm: [this.anioActual],
            mesForm: [this.mesActual],

        });
    }
    generarXML(){
        this.anioXML = this.myForm.controls['anioForm'].value;
        this.mesXML = this.myForm.controls['mesForm'].value;
        this.getDataXML();
    }

    getDataXML(){
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
          };
        this._generalService.metodoCallParams(params, 'Cuenta/gedDataXML').subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.list_XML = tableResult.Table;
               this.rfcCompany = tableResult.Table1[0]['RFC'];
                
               const mes = this.meses.find((element) => element.valor === this.myForm.controls['mesForm'].value);
               let mesName = mes.nombre;
                this.downloadXml(this.list_XML, 'Reporte de Cuenta '+this.anioXML+'-'+mesName);
                
            }, (error) => {
              console.log(error as any);
        });
    }
    downloadXml(array: any[], fileName: string): void {
        const xmlString: string = this.arrayToXml(array);
        const blob = new Blob([xmlString], { type: 'application/xml' });
        const url = window.URL.createObjectURL(blob);
        
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
    
        // Liberar recursos
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.cerrarModal();
    }
    
    arrayToXml(array) {
        let RFC = this.rfcCompany;
        let Mes = this.mesXML.toString().padStart(2, '0');
        let Anio =  this.anioXML;
        let xmlString = `<catalogocuentas:Catalogo xmlns:catalogocuentas="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/CatalogoCuentas" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/CatalogoCuentas" Version="1.3" xsi:schemaLocation="http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/CatalogoCuentas http://www.sat.gob.mx/esquemas/ContabilidadE/1_3/CatalogoCuentas/CatalogoCuentas_1_3.xsd" RFC="${RFC}" Mes="${Mes}" Anio="${Anio}">\n`;
    
        array.forEach(item => {
            xmlString += `<catalogocuentas:Ctas `;
            Object.keys(item).forEach(key => {
                xmlString += `${key}="${item[key]}" `;
            });
            xmlString += `/>\n`;
        });
    
        xmlString += '</catalogocuentas:Catalogo>';
    
        return xmlString;
    }
    


}
    


// WEBPACK FOOTER //
// ./src/app/Contabilidad/cuentas/consultar/archivoXML/cuenta-generarXML.componen..ts